import { Node } from "slate";

import { emptyDocs, Item, Meta, Photos } from "_types/item";
import { descriptionFromApi, descriptionToApi } from "_utils/description";

export interface FormData extends Meta {
  description: Node[];
}

export const formDataFromItem = (item: Item) => ({
  ...item.meta,
  description: descriptionFromApi(item.description)
}) as FormData;

export const formDataToItem = (uuid: string, data: FormData, photos: Photos) => ({
  uuid,
  meta: {
    model: data.model,
    serialNumber: data.serialNumber,
    productionDate: data.productionDate,
    isFeatured: data.isFeatured
  },
  description: descriptionToApi(data.description),
  photos,
  docs: emptyDocs()
}) as Item;
